import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar } from "@fortawesome/free-solid-svg-icons";

const VehicleFilter = ({
  loadingMakes,
  vehicleMakes,
  selectedMake,
  handleMakeSelect,
  models,
  selectedModel,
  handleModelSelect,
  t,
}) => (
  <div className="mb-6">
    <div className="flex items-center gap-2 mb-2">
      <FontAwesomeIcon icon={faCar} className="text-gray-500" />
      <h2 className="text-md font-semibold">
        {t("explore.filter_by_vehicle")}
      </h2>
    </div>

    {loadingMakes ? (
      <div className="text-center py-2">
        <div className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-primary-400 border-r-transparent"></div>
      </div>
    ) : (
      <>
        {/* Makes Filter */}
        <div className="mb-3">
          <h3 className="text-sm font-medium text-gray-700 mb-2">
            Select Make:
          </h3>
          <div className="flex flex-wrap gap-2 mb-2">
            {vehicleMakes.slice(0, 10).map((make) => (
              <button
                key={make.name}
                onClick={() => handleMakeSelect(make.name)}
                className={`px-3 py-1.5 rounded-full text-sm transition-all duration-200 ${
                  selectedMake === make.name
                    ? "bg-primary-500 text-white shadow-md scale-105 hover:bg-primary-600 dark:bg-gray-700 dark:text-gray-400"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
                }`}
              >
                {make.name}
              </button>
            ))}
            {vehicleMakes.length > 10 && (
              <select
                onChange={(e) => handleMakeSelect(e.target.value)}
                value={selectedMake}
                className="px-3 py-1.5 rounded-full text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
              >
                <option value="">More makes...</option>
                {vehicleMakes.slice(10).map((make) => (
                  <option key={make.name} value={make.name}>
                    {make.name}
                  </option>
                ))}
              </select>
            )}
            {selectedMake && (
              <button
                onClick={() => handleMakeSelect(selectedMake)}
                className="text-gray-500 hover:text-gray-700 text-sm dark:text-gray-400"
              >
                {t("explore.clear_make")}
              </button>
            )}
          </div>
        </div>

        {/* Models Filter - only show if a make is selected */}
        {selectedMake && models.length > 0 && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-2">
              Select Model:
            </h3>
            <div className="flex flex-wrap gap-2">
              {models.slice(0, 10).map((model) => (
                <button
                  key={model.name}
                  onClick={() => handleModelSelect(model.name)}
                  className={`px-3 py-1.5 rounded-full text-sm transition-all duration-200 ${
                    selectedModel === model.name
                      ? "bg-primary-500 text-white shadow-md scale-105 hover:bg-primary-600 dark:bg-gray-700 dark:text-gray-400"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
                  }`}
                >
                  {model.name}
                </button>
              ))}
              {models.length > 10 && (
                <select
                  onChange={(e) => handleModelSelect(e.target.value)}
                  value={selectedModel}
                  className="px-3 py-1.5 rounded-full text-sm bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  <option value="">More models...</option>
                  {models.slice(10).map((model) => (
                    <option key={model.name} value={model.name}>
                      {model.name}
                    </option>
                  ))}
                </select>
              )}
              {selectedModel && (
                <button
                  onClick={() => handleModelSelect(selectedModel)}
                  className="text-gray-500 hover:text-gray-700 text-sm dark:text-gray-400 dark:hover:text-gray-200"
                >
                  {t("explore.clear_model")}
                </button>
              )}
            </div>
          </div>
        )}
      </>
    )}
  </div>
);

export default VehicleFilter;
